import { DisplayQRCode } from './DisplayQRCode.js';
export default DisplayQRCode;